import React from 'react';
import { Button } from 'antd';
import { FormOutlined, SaveOutlined, StopOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { monthlyOrderStatuses } from '../../../interfaces';
import { useMonthlyOrder } from '../../../hooks/stores/useMonthlyOrderStores';
import { patchMonthlyOrderPoNumber } from '../../../middleware';
import { tB, tF } from '../../../translate';
import { InputDebounce } from '../../Forms';
import CardStyles from '../../styles/m_itemCardStyles.less';
import Styles from '../m_styles.less';

export const PoNumberFlow: React.FC = () => {
    const [isEditing, setIsEditing] = React.useState<boolean>(false);
    const [value, setValue] = React.useState<string | undefined>();
    const { id, status: monthlyOrderStatus, purchaseOrderNumber } = useMonthlyOrder();

    const savePoNumber = async (): Promise<void> => {
        const isOk = await patchMonthlyOrderPoNumber({ id, numberOrder: value || '' });
        if (isOk) {
            setIsEditing(false);
        }
    };

    return isEditing ? (
        <>
            <span className={Styles.poNumberField}>
                <InputDebounce
                    className={Styles.field}
                    isEmptyValueAvailable
                    onChange={(a) => setValue(a.currentTarget.value)}
                    placeholder={tF('Purchase Order Number')}
                    value={purchaseOrderNumber}
                />
                <Button
                    className={cx(CardStyles.mainButton, Styles.button)}
                    icon={<SaveOutlined />}
                    onClick={savePoNumber}
                    type="primary"
                >
                    {tB('Save')}
                </Button>
                <Button
                    className={cx(CardStyles.mainButton, Styles.button)}
                    icon={<StopOutlined />}
                    onClick={() => setIsEditing(false)}
                    type="primary"
                >
                    {tB('Cancel')}
                </Button>
            </span>
        </>
    ) : (
        <span className={Styles.poNumberField}>
            {purchaseOrderNumber ? <span className={Styles.field}>{purchaseOrderNumber}</span> : null}
            {monthlyOrderStatus === monthlyOrderStatuses.DRAFT ? (
                <Button
                    className={cx(CardStyles.mainButton, Styles.button)}
                    icon={<FormOutlined />}
                    onClick={() => setIsEditing(true)}
                    type="primary"
                >
                    {tB('Edit')}
                </Button>
            ) : null}
        </span>
    );
};
